import moment from "moment";
import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import "react-select/dist/react-select.css";
import * as API from "../../../../utils/api";
import { showToast } from "../../../../utils/helpers";
import AppCanvasLoader from "../../../App/AppCanvasLoader";
import Modal from "../Modal";
import CancelRefundAmountModal from "./CancelRefundAmountModal";

class CancelRefundPaymentModal extends Component {
  state = {
    cancelList: [],
    currentRow: {},
    showRefundModal: false,
    isLoading: true,
    responseMessage: "",
    showMessage: false,
    isSuccess: false,
    error: {
      hasAnyError: false,
      statusCode: 200,
    },
  };

  componentDidMount() {
    //get invoice id from invoice details page
    let invoice_id = this.props.optionalProps.invoiceDetails.id;
    //get list of payments to cancel
    this.getCancelRefundList(invoice_id);
  }

  getCancelRefundList = (invoice_id) => {
    API.getCancelRefundList(this.props.user, invoice_id).then((data) => {
      if (data && data.status_code && data.status_code == 200) {
        if (data.data) {
          this.setState({ cancelList: data.data });
        }
        this.setState({ isLoading: false });
      } else {
        this.setState((state) => ({
          ...state,
          error: {
            hasAnyError: true,
            statusCode: data
              ? data.status ||
                (data.message && data.message == "Access denied."
                  ? 401
                  : 500) ||
                500
              : 500,
          },
          isLoading: false,
        }));
      }
    });
  };

  //on cancel action open modal form to cancel payment
  refundPayment = (event, row) => {
    event.preventDefault();
    this.setState({ currentRow: row, showRefundModal: true });
  };

  //close popup modal
  handleModalClose = () => {
    this.props.hideModal();
  };

  //hide cancel payment modal
  hideRefundModal = () => {
    this.setState({ showRefundModal: false, currentRow: {} });
  };

  //render table headers
  getHeaders = () => {
    return (
      <div style={StyleSheet.headerView}>
        <h4 style={StyleSheet.date}>Date</h4>
        <h4 style={StyleSheet.amount}>Amount</h4>
        <h4 style={StyleSheet.amount}>Method</h4>
        <h4 style={StyleSheet.amount}>Action</h4>
      </div>
    );
  };

  render() {
    let {
      error,
      isLoading,
      cancelList,
      isSuccess,
      currentRow,
      showMessage,
      showRefundModal,
      responseMessage,
    } = this.state;
    let { optionalProps } = this.props;

    if (error.hasAnyError) {
      if (error.statusCode == 500) {
        showToast();
        this.setState({
          error: {
            ...this.state.error,
            hasAnyError: false,
            statusCode: 200,
          },
        });
      } else if (error.statusCode == 401) {
        return <Redirect to={{ pathname: "/sign-out" }} />;
      } else {
        this.props.updateModalState(true, "OTHER_ERROR", true);
        return <Redirect to={{ pathname: "/sign-out" }} />;
      }
    }

    if (showRefundModal) {
      return (
        <CancelRefundAmountModal
          user={this.props.user}
          currentRow={currentRow}
          reloadPage={optionalProps.reloadData}
          hideModal={this.hideRefundModal}
          invoiceDetails={this.props.optionalProps.invoiceDetails}
          updateModalState={this.props.updateModalState}
        />
      );
    }

    return (
      <Modal
        optionalClasses="add-account-modal send-new-email-modal scroll ce-mo"
        title="Cancel Payment"
        closeOnClickOutside={true}
        hideModal={this.props.hideModal}
      >
        {showMessage ? (
          <div style={{ marginTop: "7em" }}>
            <div
              className="flash"
              style={
                isSuccess ? { justifyContent: "center" } : StyleSheet.success
              }
            >
              {responseMessage}
            </div>
          </div>
        ) : isLoading ? (
          <AppCanvasLoader />
        ) : (
          <div style={{ marginTop: "0.5em" }}>
            {cancelList && cancelList.length ? this.getHeaders() : null}
            {cancelList && cancelList.length ? (
              cancelList.map((row, i) => {
                return (
                  <div key={"_" + i} style={StyleSheet.body}>
                    <div style={StyleSheet.dateValue}>
                      {row.date ? moment(row.date).format("MM/DD/YYYY") : "n/a"}
                    </div>
                    <div style={StyleSheet.fullWidth}>
                      ${row.amount ? parseFloat(row.amount).toFixed(2) : "0.00"}
                    </div>
                    <div style={StyleSheet.fullWidth}>{row.payment_type}</div>
                    <div className="in-new-btn" style={StyleSheet.fullWidth}>
                      <button
                        id={`refund${row.id}`}
                        style={StyleSheet.cancelBtn}
                        onClick={(event) => this.refundPayment(event, row)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                className="admin-admins-empty-state"
                style={StyleSheet.empty}
              >
                <p>No payments available to cancel.</p>
              </div>
            )}
          </div>
        )}
      </Modal>
    );
  }
}

let StyleSheet = {
  headerView: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    padding: "0.5em",
  },
  date: {
    margin: "0px 10px 0px 0px",
    width: "100%",
    fontSize: "1em",
    color: "#9b9b9b",
  },
  amount: {
    margin: 0,
    width: "100%",
    fontSize: "1em",
    color: "#9b9b9b",
  },
  body: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    border: "1px solid #e1e1e1",
    borderRadius: 4,
    marginBottom: "1em",
    padding: "0.5em",
  },
  empty: {
    padding: "2rem 2rem 1rem 2rem",
    backgroundColor: "#FFF",
  },
  success: {
    backgroundColor: "#fb5c82",
    borderColor: "#fb5c82",
    justifyContent: "center",
  },
  dateValue: { margin: "0px 10px 0px 0px", width: "100%" },
  fullWidth: { margin: 0, width: "100%" },
  cancelBtn: { padding: "1em 2em 0.8em", margin: 0, fontWeight: 600 },
};

export default withRouter(CancelRefundPaymentModal);
